{
  "_meta": {
    "asOf": "2023",
    "source": "BLS Consumer Expenditure Survey 2022-2023 'Income before taxes' fifth quintile (≥$240K). Per-state taxable share approximated as 0.55 × total expenditure for states without grocery exemptions, 0.45 × for states that exempt groceries (most). REPLACE with category-by-category build per state.",
    "schema": "USD annual taxable consumption at the labeled spending percentile"
  },
  "_quintile5_total": 137000,
  "_default_taxable_share": 0.45,
  "AL": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "AK": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "AZ": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "AR": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "CA": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "CO": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "CT": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "DE": {"p50": 0, "p70": 0, "p80": 0, "p90": 0, "p95": 0},
  "DC": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "FL": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "GA": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "HI": {"p50": 36000, "p70": 46800, "p80": 54000, "p90": 66600, "p95": 86400},
  "ID": {"p50": 36000, "p70": 46800, "p80": 54000, "p90": 66600, "p95": 86400},
  "IL": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "IN": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "IA": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "KS": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "KY": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "LA": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "ME": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "MD": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "MA": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "MI": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "MN": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "MS": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "MO": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "MT": {"p50": 0, "p70": 0, "p80": 0, "p90": 0, "p95": 0},
  "NE": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "NV": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "NH": {"p50": 0, "p70": 0, "p80": 0, "p90": 0, "p95": 0},
  "NJ": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "NM": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "NY": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "NC": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "ND": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "OH": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "OK": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "OR": {"p50": 0, "p70": 0, "p80": 0, "p90": 0, "p95": 0},
  "PA": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "RI": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "SC": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "SD": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "TN": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "TX": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "UT": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "VT": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "VA": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "WA": {"p50": 33000, "p70": 42900, "p80": 49500, "p90": 61050, "p95": 79200},
  "WV": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "WI": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000},
  "WY": {"p50": 30000, "p70": 39000, "p80": 45000, "p90": 55500, "p95": 72000}
}
